import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=024e35cb&scoped=true&"
import script from "./search-box.vue?vue&type=script&lang=js&"
export * from "./search-box.vue?vue&type=script&lang=js&"
import style0 from "./search-box.vue?vue&type=style&index=0&id=024e35cb&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e35cb",
  null
  
)

export default component.exports